import { createSlice } from '@reduxjs/toolkit';
import { extraReducers } from './async-thunks';
import { initialState, SLICE_NAMESPACE } from './uploads.constants';

const uploadsSlice = createSlice({
  name: SLICE_NAMESPACE,
  initialState,
  reducers: {},
  extraReducers,
});

export default uploadsSlice.reducer;
